// TODO: https://github.com/combinaut/sparkle/issues/31058 rewrites this into SpFinder and deletes legacy/

/** Creates an HTML renderer that retains the finder host and optionally its filter/sort controls. */
export function createEventsRenderer(host) {
  function render(html, { refreshUI = false, scrollIntoView = false } = {}) {
    const content = document.createElement("template");
    content.innerHTML = html;
    const wrapper = content.content.querySelector('sp-finder[kind="events"]');
    if (!wrapper) {
      throw new Error("Events results response is missing its finder wrapper");
    }
    if (!refreshUI) {
      for (const selector of ["#search-by-filters", ".events-index__sort"]) {
        const existing = host.querySelectorAll(selector);
        const replacements = wrapper.querySelectorAll(selector);
        existing.forEach((node, index) => {
          node.querySelectorAll("script").forEach((script) => script.remove());
          replacements[index]?.replaceWith(node);
        });
      }
    }
    wrapper.querySelectorAll("script[src]").forEach((script) => script.remove());
    const scripts = [...wrapper.querySelectorAll("script")];
    host.replaceChildren(...wrapper.childNodes);
    for (const script of scripts) {
      const executable = document.createElement("script");
      for (const attribute of script.attributes) {
        executable.setAttribute(attribute.name, attribute.value);
      }
      executable.textContent = script.textContent;
      script.replaceWith(executable);
    }
    if (scrollIntoView) {
      host.scrollIntoView(true);
      document.body.scrollIntoView(true);
    }
  }
  return render;
}
